import { render, staticRenderFns } from "./Reserved.vue?vue&type=template&id=0b9fb1a4&scoped=true"
import script from "./Reserved.vue?vue&type=script&lang=js"
export * from "./Reserved.vue?vue&type=script&lang=js"
import style0 from "./Reserved.vue?vue&type=style&index=0&id=0b9fb1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9fb1a4",
  null
  
)

export default component.exports